import Api from "./api.jsx";

const NotificationSeverities = Object.freeze(["info", "warning", "error"]);

const unwrapApiEnvelope = (data) => {
  if (!data || typeof data !== "object") return data;
  if (data?.response != null) return data.response;
  return data;
};

const buildGetAllNotificationsPayload = (payload) => {
  const page = Number(payload?.page ?? 1);
  const pageSize = Number(payload?.pageSize ?? 20);
  const unreadOnly = Boolean(payload?.unreadOnly);
  const type = payload?.type ? String(payload.type) : null;
  const severity = payload?.severity ? String(payload.severity) : null;
  const normalizedSeverity = NotificationSeverities.includes(severity) ? severity : null;

  return {
    page: Number.isFinite(page) && page > 0 ? page : 1,
    pageSize: Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 20,
    unreadOnly,
    type,
    severity: normalizedSeverity,
  };
};

const getUnreadCount = async () => {
  const { data } = await Api.get("/notifications/unread-count");
  const raw = unwrapApiEnvelope(data);
  const unread = Number(raw?.unread ?? raw?.data?.unread ?? 0);
  return { unread: Number.isFinite(unread) && unread >= 0 ? unread : 0 };
};

const getAllNotifications = async (payload) => {
  const { data } = await Api.post("/notifications/getAll", buildGetAllNotificationsPayload(payload));
  const raw = unwrapApiEnvelope(data);
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.data)) return raw.data;
  if (Array.isArray(raw?.items)) return raw;
  return raw;
};

const markNotificationRead = async (id) => {
  await Api.post(`/notifications/${id}/read`);
};

const markNotificationUnread = async (id) => {
  await Api.post(`/notifications/${id}/unread`);
};

const markNotificationsReadBatch = async (notificationIds) => {
  await Api.post("/notifications/read-batch", { notificationIds });
};

export default {
  NotificationSeverities,
  buildGetAllNotificationsPayload,
  getUnreadCount,
  getAllNotifications,
  markNotificationRead,
  markNotificationUnread,
  markNotificationsReadBatch,
};
